export default "__VITE_ASSET__485a2b9a__"